

export class TimeZoneOutputWithoutStatus implements ITimeZoneOutputWithoutStatus {
    /** The auto-generated id of the time zone master */
    time_zone_id!: number;
    /** The time zone with 255 character limit */
    time_zone!: string;
    /** The time difference between time zone time zone master */
    time_difference!: number;

    constructor(data?: ITimeZoneOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time_zone_id = _data["time_zone_id"];
            this.time_zone = _data["time_zone"];
            this.time_difference = _data["time_difference"];
        }
    }

    static fromJS(data: any): TimeZoneOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time_zone_id"] = this.time_zone_id;
        data["time_zone"] = this.time_zone;
        data["time_difference"] = this.time_difference;
        return data; 
    }
}

export interface ITimeZoneOutputWithoutStatus {
    /** The auto-generated id of the time zone master */
    time_zone_id: number;
    /** The time zone with 255 character limit */
    time_zone: string;
    /** The time difference between time zone time zone master */
    time_difference: number;
}

